import api from './interceptor';

const BASE_URL_V2_CARDS = 'api/v2/card';

export default {
  // API Version 2
  addCard: (params) => api.post(`${BASE_URL_V2_CARDS}`, params),
  deleteCard: (params) => api.delete(`${BASE_URL_V2_CARDS}`, { data: params }),
};
